var _path, _path2, _text, _path3, _text2, _path4, _path5, _text3, _path6, _path7, _rect, _path8, _text4, _path9, _path10, _text5, _path11, _path12, _text6, _path13, _text7, _rect2, _path14, _text8, _path15, _path16, _text9, _path17, _path18, _path19, _path20, _path21, _text10, _path22, _path23, _path24, _path25, _text11, _path26, _path27, _text12, _switch;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlowDiagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      backgroundColor: "rgb(255, 255, 255)"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "557px",
    height: "316px",
    viewBox: "-0.5 -0.5 557 316",
    content: "<mxfile host=\"app.diagrams.net\" modified=\"2024-01-09T01:34:44.741Z\" agent=\"Mozilla/5.0 (Macintosh; Intel Mac OS X 10.15; rv:121.0) Gecko/20100101 Firefox/121.0\" etag=\"JbpP3xf65HVVWyIRBJeZ\" version=\"22.1.17\" type=\"device\"><diagram name=\"Page-1\" id=\"_B8hAXgzcJ6p9K9PPbYA\">7VpZb+M2EP41fowgiTrsx/jY7cOmSGMU3T4FtERbbCRRJSkf++tLWpR1ULHjRLYToAhgeIZD8Zhv5puRMwCTZPudwix6ICGKB7YZbgdgOrDtkeuIT6nYFQrP8gvFiuKwUFmVYo5/IaU0lTbHIWINQ05IzHHWVAYkTVHAGzpIKdk0zZYkbq6awRXSFPMAxrr2LxzyqNAOXbPS/4bwKipXtkw1ksDSWClYBEOyqanAbAAmlBBefEu2ExTLuyvvpZj37ZXRw8YoSvlbJjz8zhl9tMid/8fTdHcH1mgB7iz1mDWMc3Vi1xDyn1lMYCgHMBSfG7QQnzFOX9RZ+K68IBSK+1IioTwiK5LCeFZpx5TkaYjkLkwhVTY/CMmE0hLKfxDnO+V8mHMiVBFPYjWqn1TtmpGcBujI8WyFGEhXiB+xcws7eZbaAuoevyOSIE53woCiGHK8bmIDKoitDnZq6j2lcFczyAhOOas9+VEqhIEKFqdElYoVF7Q8ep69+FLsoJRqR6lUe5ScgRhbA8wTSghHQrfIGU4RY4WzeIqohpY1ohyL6PoBFyh+JAxzTFIxtCCck6Tp9tL2PsYracMlXMZQSYEAg1gAjBmn5AVNSEyENE1JKjG3xHFcqgY2MM3x7JstjSOYya0k25VMVwb8lVNk5Gz/pFdxJneCtkeRoUZtp+kSZ6SgtamSh+MbShnVMkfpyy401Tx6vsM8zWGWjPAn9G+OmEQTy7NMRCVOVzJPkyBPkILp1wl0cJEA1iLOHjXdC4YHX5YPKXKNmle57uxcYLdXGh7PBcftL5MLLPCpUHKjNK/5wgOgmQScVmwXcP4wRrR1/ON8ccL+MhgBWvqZ5EzkekkOpsi7axxI7iDLpfiiEwZ7QTyIFFj2F4LobL1PUAUaDmWVNAghiw7QqkHmLRzhmvJP6OMWNx2Y5iR5dTMWybmonMTqZYVqdtJYi5mKC9lTEzPEM+PnwvRZVJwS932wlWe1koZn6mzldXBVK+f1xlUjDSygyVU1ejKXVFy6bQIaqoJjd4tshLaY/5TTBREU0t9yxHCUNN2qZ++FXU14RBSLa5Pe3+vez37OldjPa+WPUSuvvcJ9vdGNqcHDbjQrsv6URYxASy6TSponi46cckVUWHVMXB8RvTGiQsCdadhDU026cDPUKmgc60Qz1LJ3rSPkVs0utyPSLUMXQa2jgXb8f5/U7pM6mee6fZKr+WkeiSPKvCLfGp2qTSDLCnZf4q3MHD0XK30XJRo8NCRYw+G0AwkJCyAy9rMyihky2P6Wnut39MGixCr9fqyJBleEhjXUsPFV34hZV6sVnGY69q9cK+hpV3NUIwA7q/TalWsB03dEtgNNIAwHJGUGS5gen0Nv6nie0AvjEIula2OOPXZKyH4oFB2zxam+Hohl0F0nEPUG4csG4jtKr1FZgN8oOK9ZNlk6H2sO7ozZRlT3xY51em6XRhsGDJRAHOtROh3d+47VEaWK1XuIUTAaNXzpgY4YtQ1vqIdp+7VUf2Gqv3N23vbOWf3eNH+Y3yKaxR7o7mddkH2baXilWLVue2lXl/pr3lSQn2ze3szlCiqm4Vqe/54Mcm7z5mtvo/3uPPKKvad6zJs3b+Wv1e9GcpEYPhGW3U+K5TPpUBzEN0dfAsvuxbEsxOr/CArz6p8xwOw/</diagram></mxfile>",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "0%",
    x2: "0%",
    y2: "100%",
    id: "mx-gradient-86d466-1-42b418-1-s-0"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(134, 212, 102)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(66, 180, 24)",
      stopOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 114.5 170 L 277 170 L 432.13 170",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 437.38 170 L 430.38 173.5 L 432.13 170 L 430.38 166.5 Z",
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 170,
      marginLeft: 277
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    },
    "data-drawio-colors": "color: rgb(0, 0, 0); background-color: rgb(255, 255, 255); "
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 11,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      backgroundColor: "rgb(255, 255, 255)",
      whiteSpace: "nowrap"
    }
  }, "5. Upload via web link")))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 277,
    y: 173,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "11px",
    textAnchor: "middle"
  }, "5. Upload via web link")))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 80.58 149.39 C 80.51 145.61 81.78 141.96 84.11 139.25 C 86.44 136.55 89.63 135.01 92.96 135 C 100.4 135.08 106.47 141.48 106.74 149.54 C 107.02 153.24 105.9 156.91 103.63 159.69 C 101.37 162.46 98.16 164.1 94.75 164.23 C 87.22 164.39 80.94 157.81 80.58 149.39 Z M 67 185 C 67.3 177.97 69.91 171.42 74.21 166.94 C 77.62 163.56 82.37 163.36 85.95 166.44 C 88 167.95 90.24 169.17 92.62 170.06 C 95.06 171.12 97.74 170.94 100.08 169.56 C 101.36 168.94 102.5 168.04 103.41 166.94 C 104.31 165.86 105.88 165.64 107.04 166.44 C 109.09 167.81 110.92 170.24 112.36 173.48 C 113.75 177.16 114.48 181.05 114.5 184.99 Z",
    fill: "#00bef2",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe flex-start",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 192,
      marginLeft: 91
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    },
    "data-drawio-colors": "color: rgb(0, 0, 0); "
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "nowrap"
    }
  }, "Remote business partner")))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 91,
    y: 204,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Remote b...")))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 437 27.5 L 247 27.5 L 123.37 27.5",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M 118.12 27.5 L 125.12 24 L 123.37 27.5 L 125.12 31 Z",
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 28,
      marginLeft: 277
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    },
    "data-drawio-colors": "color: rgb(0, 0, 0); background-color: rgb(255, 255, 255); "
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 11,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      backgroundColor: "rgb(255, 255, 255)",
      whiteSpace: "nowrap"
    }
  }, "1. Request supporting documents")))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 277,
    y: 31,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "11px",
    textAnchor: "middle"
  }, "1. Request supporting documents")))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M 460 80 L 460 110 L 460 128.63",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M 460 133.88 L 456.5 126.88 L 460 128.63 L 463.5 126.88 Z",
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 437,
    y: 0,
    width: 46,
    height: 55,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M 456.21 32.78 C 455.54 32.77 454.82 32.52 454.46 31.87 C 452.25 31.76 449.46 30.58 447.46 28.2 C 445.81 26.22 445.21 24.05 445.15 21.85 L 445.16 18.7 C 444.75 18.73 444.08 18.38 444.03 17.61 C 444.05 16.44 444.12 15.41 444.26 14.61 C 445.3 7.86 450.52 0.49 459.45 0.11 C 468.56 0 474.49 7.65 475.39 14.81 C 475.53 15.78 475.6 16.68 475.59 17.64 C 475.55 18.25 475.02 18.7 474.46 18.7 C 474.62 20.63 472.65 23.29 470.81 23.77 C 469.27 24.13 469.37 22.8 469.31 21.67 L 469.31 16.23 C 469.32 15.3 469.44 14.46 470.42 14.49 C 471.68 14.51 472.63 15.12 473.26 15.75 C 472.51 8.52 466.91 2.16 459.43 2.37 C 452.9 2.64 447.36 7.87 446.39 15.57 C 447.28 14.78 448.27 14.52 449.09 14.49 C 449.98 14.44 450.21 14.92 450.24 15.99 L 450.24 21.73 C 450.24 23.74 449.84 23.9 448.95 23.8 C 448.12 23.61 447.14 22.9 446.19 21.54 C 446.07 26.14 449.48 30.43 454.57 30.82 C 454.95 30.29 455.6 30.03 456.16 30.01 L 460.85 30.01 C 461.67 30.03 462.61 30.58 462.66 31.4 C 462.68 32.11 461.69 32.76 460.85 32.78 Z M 460.83 28.42 L 456.2 28.42 C 455.89 28.42 455.57 28.45 455.21 28.56 C 453.85 27.97 452.06 26.51 450.92 24.79 C 451.43 24.34 451.72 23.44 451.74 22.45 L 451.74 15.91 C 451.71 13.93 450.63 13.07 449.19 13.05 C 450.61 8.47 454.55 4.63 459.79 4.63 C 464.85 4.63 468.87 8.27 470.39 12.98 C 469.09 13.01 467.84 13.89 467.89 16.21 L 467.89 22.44 C 467.89 23.05 468.06 24.2 468.72 24.82 C 467.34 26.73 465.58 28.27 463.01 29.2 C 462.4 28.69 461.56 28.42 460.83 28.42 Z M 437 55 C 437.52 49.44 438.22 41.85 439.54 38 C 440.15 36.27 441.04 35.01 442.47 33.97 C 443.4 33.26 446.7 31.44 447.31 31.13 C 447.53 31.02 447.76 30.91 447.98 30.83 C 449.52 32.12 451.68 33.07 453.52 33.28 C 458.65 35.92 464.8 35.13 469.42 31.14 C 470.08 30.47 471.12 30.65 471.81 30.92 C 472.9 31.34 476.38 33.4 477.04 33.84 C 478.96 35.1 480 36.79 480.78 39.98 C 481.75 44.28 482.33 49.75 483 55 Z",
    fill: "#505050",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe flex-start",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 62,
      marginLeft: 460
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    },
    "data-drawio-colors": "color: rgb(0, 0, 0); "
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "nowrap"
    }
  }, "Customer service officer")))), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 460,
    y: 74,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Custome...")))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M 90.75 70 L 90.8 90 L 90.13 123.63",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M 90.02 128.88 L 86.66 121.81 L 90.13 123.63 L 93.66 121.95 Z",
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 100,
      marginLeft: 90
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    },
    "data-drawio-colors": "color: rgb(0, 0, 0); background-color: rgb(255, 255, 255); "
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 11,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      backgroundColor: "rgb(255, 255, 255)",
      whiteSpace: "nowrap"
    }
  }, "3. Request documents from 3rd party")))), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 90,
    y: 103,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "11px",
    textAnchor: "middle"
  }, "3. Request documents from 3rd party")))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M 114.5 50 L 247 50 L 247 150 L 432.13 150",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M 437.38 150 L 430.38 153.5 L 432.13 150 L 430.38 146.5 Z",
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 71,
      marginLeft: 247
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    },
    "data-drawio-colors": "color: rgb(0, 0, 0); background-color: rgb(255, 255, 255); "
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 11,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      backgroundColor: "rgb(255, 255, 255)",
      whiteSpace: "nowrap"
    }
  }, "2. Upload using queue number")))), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 247,
    y: 74,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "11px",
    textAnchor: "middle"
  }, "2. Upload using queue number")))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M 80.58 14.39 C 80.51 10.61 81.78 6.96 84.11 4.25 C 86.44 1.55 89.63 0.01 92.96 0 C 100.4 0.08 106.47 6.48 106.74 14.54 C 107.02 18.24 105.9 21.91 103.63 24.69 C 101.37 27.46 98.16 29.1 94.75 29.23 C 87.22 29.39 80.94 22.81 80.58 14.39 Z M 67 50 C 67.3 42.97 69.91 36.42 74.21 31.94 C 77.62 28.56 82.37 28.36 85.95 31.44 C 88 32.95 90.24 34.17 92.62 35.06 C 95.06 36.12 97.74 35.94 100.08 34.56 C 101.36 33.94 102.5 33.04 103.41 31.94 C 104.31 30.86 105.88 30.64 107.04 31.44 C 109.09 32.81 110.92 35.24 112.36 38.48 C 113.75 42.16 114.48 46.05 114.5 49.99 Z",
    fill: "#00bef2",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe flex-start",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 57,
      marginLeft: 91
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    },
    "data-drawio-colors": "color: rgb(0, 0, 0); "
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "nowrap"
    }
  }, "Business partner")))), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 91,
    y: 69,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Business...")))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 438.5,
    y: 135,
    width: 43,
    height: 50,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M 441.87 171.95 C 440.09 171.88 438.65 170.51 438.5 168.75 L 438.5 144.24 C 438.78 142.64 440.13 141.43 441.77 141.34 L 456.84 141.34 C 457.52 141.08 458.11 140.65 458.55 140.09 L 461.17 137.24 C 462.29 135.84 464.04 135.07 465.84 135.19 L 473.43 135.19 C 474.73 135 476.05 135.38 477.05 136.24 L 479.86 138.99 C 480.75 140.02 481.3 141.29 481.42 142.64 L 481.42 168.35 C 481.5 170.09 480.28 171.63 478.55 171.95 L 461.12 171.95 L 461.12 174.3 L 458.7 174.3 L 458.7 171.95 Z M 452.82 179.05 L 452.82 181.45 L 438.5 181.45 L 438.5 179.05 Z M 454.08 177.4 C 454.3 176.48 455.02 175.77 455.94 175.55 L 463.78 175.55 C 464.85 175.71 465.71 176.53 465.89 177.6 L 465.89 182.6 C 465.86 183.8 464.97 184.81 463.78 185 L 455.94 185 C 454.85 184.71 454.09 183.72 454.08 182.6 Z M 456.34 177.9 L 456.34 182.6 L 463.48 182.6 L 463.48 177.9 Z M 467.15 181.45 L 467.15 179.05 L 481.47 179.05 L 481.47 181.45 Z",
    fill: "#00188d",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe flex-start",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 192,
      marginLeft: 460
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    },
    "data-drawio-colors": "color: rgb(0, 0, 0); "
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "nowrap"
    }
  }, "Shared folder")))), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 460,
    y: 204,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Shared...")))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M 227 240 L 91.5 240 L 91.11 216.37",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M 91.02 211.12 L 94.63 218.06 L 91.11 216.37 L 87.64 218.18 Z",
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 240,
      marginLeft: 144
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    },
    "data-drawio-colors": "color: rgb(0, 0, 0); background-color: rgb(255, 255, 255); "
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 11,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      backgroundColor: "rgb(255, 255, 255)",
      whiteSpace: "nowrap"
    }
  }, "web link")))), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 144,
    y: 243,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "11px",
    textAnchor: "middle"
  }, "web link")))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M 232.37 265 C 229.4 265 227 262.58 227 259.59 L 227 220.41 C 227 217.42 229.4 215 232.37 215 L 271.63 215 C 274.6 215 277 217.42 277 220.41 L 277 259.59 C 277 262.58 274.6 265 271.63 265 Z",
    fill: "url(#mx-gradient-86d466-1-42b418-1-s-0)",
    stroke: "none",
    pointerEvents: "all"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M 238.81 255.72 C 240.89 253.78 242.03 251.59 242.74 249.38 C 238.34 246.94 235.78 243.06 235.54 238.83 C 235.46 233.67 238.56 229.33 243.84 226.8 C 249.71 224.15 256.49 224.38 261.92 227.25 C 266.47 229.77 269.32 233.83 269.32 238.38 C 269.32 242.07 267.22 247.47 260 250.38 C 256.42 251.84 252.51 252.1 249.19 251.57 C 245.67 254.25 242.16 255.32 238.81 255.72 Z M 263.12 243.74 C 264.46 243.49 265.53 242.69 265.79 241.62 C 265.99 240.74 265.87 239.76 265.07 239.14 C 264.36 238.57 263.27 238.37 262.46 238.2 C 261.84 238.06 261.05 237.94 260.88 237.57 C 260.74 237.28 260.79 236.98 261.06 236.74 C 261.43 236.44 262 236.38 262.49 236.38 C 263.76 236.41 264.76 236.95 265.3 237.37 L 265.54 237.37 L 265.54 235.36 C 264.38 234.9 262.05 234.4 260.26 235.16 C 259.35 235.59 258.59 236.23 258.5 237.34 C 258.44 238.64 259.03 239.28 259.67 239.66 C 260.94 240.34 261.71 240.26 262.79 240.57 C 263.17 240.67 263.61 240.93 263.58 241.4 C 263.56 241.73 263.38 241.88 263.12 242.01 C 262.67 242.26 261.76 242.29 260.99 242.14 C 260.05 241.94 259.2 241.52 258.69 241.07 L 258.45 241.07 L 258.44 243.17 C 259.83 243.77 261.49 244.02 263.12 243.74 Z M 249.69 243.69 L 249.69 237.82 L 251.31 241.63 L 252.86 241.63 L 254.47 237.82 L 254.47 243.69 L 256.7 243.69 L 256.7 234.93 L 254.1 234.93 L 252.14 239.33 L 250.19 234.93 L 247.58 234.93 L 247.58 243.69 Z M 238.6 243.16 C 240.08 243.81 241.49 243.95 242.99 243.78 C 244.22 243.61 245.29 243.07 245.81 242.01 C 246.14 241.32 246.17 240.13 245.5 239.4 C 244.91 238.75 243.93 238.5 243.21 238.32 C 242.56 238.17 241.81 238.08 241.32 237.84 C 241.02 237.7 240.84 237.31 241.03 236.95 C 241.33 236.49 241.98 236.39 242.56 236.38 C 243.67 236.35 244.81 236.88 245.45 237.38 L 245.69 237.37 L 245.69 235.36 C 244.82 235.03 243.59 234.73 242.23 234.78 C 240.93 234.84 239.86 235.25 239.11 236.13 C 238.42 237.06 238.63 238.19 238.92 238.75 C 239.39 239.66 240.45 239.98 241.29 240.21 C 241.94 240.37 242.62 240.44 243.14 240.64 C 243.82 240.92 243.84 241.46 243.59 241.78 C 243.35 242.07 242.91 242.21 242.22 242.23 C 241.01 242.27 239.76 241.81 238.83 241.07 L 238.6 241.08 Z",
    fill: "#ffffff",
    stroke: "none",
    pointerEvents: "all"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M 227 220.41 C 227 217.42 229.4 215 232.37 215 L 271.63 215 C 274.6 215 277 217.42 277 220.41 L 277 233.58 C 261.22 241.33 242.78 241.33 227 233.58 Z",
    fillOpacity: 0.2,
    fill: "#ffffff",
    stroke: "none",
    pointerEvents: "all"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M 226 295 L 91.5 295 L 91.04 216.37",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M 91.01 211.12 L 94.55 218.1 L 91.04 216.37 L 87.55 218.14 Z",
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 295,
      marginLeft: 149
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    },
    "data-drawio-colors": "color: rgb(0, 0, 0); background-color: rgb(255, 255, 255); "
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 11,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      backgroundColor: "rgb(255, 255, 255)",
      whiteSpace: "nowrap"
    }
  }, "web link")))), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 149,
    y: 298,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "11px",
    textAnchor: "middle"
  }, "web link")))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M 235.49 284.44 C 235.05 284.45 234.6 284.46 234.1 284.64 C 233.64 284.82 233.35 285.11 233.22 285.5 C 233.04 286.2 233.26 286.59 233.38 286.76 C 233.75 287.2 234.33 287.17 234.74 286.92 C 235.12 286.68 235.36 286.28 235.45 285.71 C 235.5 285.37 235.5 284.91 235.49 284.44 Z M 240.01 291.83 C 238.74 292.67 237.08 293.26 234.93 293.23 C 230.71 293.23 226 289.91 226 284.1 C 226 280.22 228.89 275 234.74 275 C 239.36 275 243.38 277.66 243.38 283.1 C 243.38 284.79 242.72 287.64 240.87 288.87 C 239.82 289.63 238.67 289.74 237.5 289.21 C 236.86 288.93 236.24 288.38 235.8 287.53 C 235.2 288.07 234.64 288.79 232.81 288.63 C 231.67 288.45 230.86 287.64 230.89 286.1 C 230.95 284.73 231.75 283.88 233.04 283.55 C 233.63 283.38 234.09 283.31 235.5 283.18 L 235.49 282.74 C 235.49 282.26 235.38 281.93 235.19 281.76 C 234.99 281.54 234.69 281.43 234.4 281.41 C 233.77 281.43 233.3 281.75 233.15 282.38 C 233.12 282.58 232.98 282.69 232.82 282.66 L 231.4 282.46 C 231.27 282.44 231.14 282.39 231.19 282.13 C 231.4 281.12 231.92 280.64 232.48 280.29 C 233.3 279.81 234.65 279.7 235.51 279.88 C 236.97 280.23 237.69 280.86 237.69 282.58 L 237.69 285.73 C 237.7 286.41 238 286.86 238.3 287.13 C 238.8 287.52 239.46 287.27 239.95 286.82 C 240.85 285.98 241.28 284.69 241.41 283.15 C 241.53 280.44 240.28 278.88 238.73 277.96 C 236.88 276.86 233.57 276.32 231.05 277.93 C 229.45 278.96 227.95 280.98 227.75 283.96 C 227.59 286.66 228.82 288.58 230.12 289.87 C 232.74 292.26 236.61 292.37 239.45 290.72 C 239.93 290.52 240.16 290.59 240.34 290.98 C 240.49 291.38 240.36 291.58 240.01 291.83 Z M 276.91 281.2 L 276.91 282.97 L 255.3 297.36 L 243.99 290.05 L 243.98 288.28 C 245.16 286.49 245.97 284.01 245.67 281.2 Z M 278.68 315 L 232.5 315 L 232.5 295.14 C 237.26 296.08 241.08 293.88 243.11 291.45 L 255.3 299.43 L 278.68 283.78 Z",
    fill: "#d9a741",
    stroke: "none",
    pointerEvents: "all"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M 276.91 281.2 L 276.91 282.97 L 255.3 297.36 L 243.99 290.05 L 243.98 288.28 L 255.3 295.59 Z M 278.68 315 L 232.5 315 L 232.5 313.23 L 278.68 313.23 Z",
    fillOpacity: 0.3,
    fill: "#000000",
    stroke: "none",
    pointerEvents: "all"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M 483 27.5 L 547 27.5 L 547 245 L 283.37 245",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M 278.12 245 L 285.12 241.5 L 283.37 245 L 285.12 248.5 Z",
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 245,
      marginLeft: 411
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    },
    "data-drawio-colors": "color: rgb(0, 0, 0); background-color: rgb(255, 255, 255); "
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 11,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      backgroundColor: "rgb(255, 255, 255)",
      whiteSpace: "nowrap"
    }
  }, "4. Request supporting documents via SMS")))), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 411,
    y: 248,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "11px",
    textAnchor: "middle"
  }, "4. Request supporting documents via SMS")))), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M 483 27.5 L 547 27.5 L 547 295 L 285.05 295",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M 279.8 295 L 286.8 291.5 L 285.05 295 L 286.8 298.5 Z",
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 295,
      marginLeft: 408
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    },
    "data-drawio-colors": "color: rgb(0, 0, 0); background-color: rgb(255, 255, 255); "
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 11,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      backgroundColor: "rgb(255, 255, 255)",
      whiteSpace: "nowrap"
    }
  }, "4. Request supporting documents via email")))), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 408,
    y: 298,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "11px",
    textAnchor: "middle"
  }, "4. Request supporting documents via email"))))), _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", {
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }), /*#__PURE__*/React.createElement("a", {
    transform: "translate(0,-5)",
    xlinkHref: "https://www.drawio.com/doc/faq/svg-export-text-problems",
    target: "_blank"
  }, /*#__PURE__*/React.createElement("text", {
    textAnchor: "middle",
    fontSize: "10px",
    x: "50%",
    y: "100%"
  }, "Text is not SVG - cannot display")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlowDiagram);
export default __webpack_public_path__ + "static/media/flow-diagram.3ef255661ad42eb13a3634643759013a.svg";
export { ForwardRef as ReactComponent };